export default __webpack_public_path__ + "static/media/7.14d19bc3.png";